var symphony = symphony || {};

;
(function () {

	var $parent = $(window);

	symphony.heroSlider = function ($elm) {

		$parent = $elm || $(window);
		var deviceWidth = $parent.width();
		var heroText = $('.heroSlider .heroText');
		var heroContainer = $('.heroContainer');
		var heroHeight = $('.heroContainer').outerHeight();
		var oneThirdHero = heroHeight / 3;
		var twoThirdsHero = oneThirdHero * 2;
		var heroSlider = heroContainer.find('.heroSlider:not(.slick-initialized)').eq(0);

		if (typeof isLocal == 'undefined') {
			isLocal = false;
		}

		function dealWithScheduledSlides() {
			var scheduledHero = heroSlider.find('.hero.not-ready')[0];
			if (scheduledHero) {
				$(scheduledHero).removeClass('not-ready');
				if (new Date() >= new Date(scheduledHero.getAttribute('data-start')) && new Date() < new Date(scheduledHero.getAttribute('data-end'))) {
					$(scheduledHero).show();
				} else {
					$(scheduledHero).remove();
				}
				dealWithScheduledSlides();
			}
		}

		dealWithScheduledSlides();

		if (!$('.heroSlider').hasClass('slick-initialized')) {
			$('.heroSlider').slick({
					fade: true,
					mobileFirst: true,
					swipeToSlide: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					arrows: false,
					fade: true,
					/*asNavFor: '.heroThumbs',*/
					asNavFor: $('.heroThumbs').length > 0 ? '.heroThumbs' : null,
					focusOnSelect: true,
					infinite: false
				})
				.find('div').css('height', '100%')
				.find('div.heroText-container').css('height', '')
				.find('div.heroText').css('height', '')
				.promise().done(configureThumbs);
		}

		function configureThumbs() {
			if ($('.heroThumbs').length > 0 && $('.heroThumbs .hero-thumb').length > 1) {
				//$('.heroSlider').addClass('hasThumbs');
				//if (!$('.heroThumbs').hasClass('slick-initialized')) {
				var sts = $('.heroThumbs .hero-thumb').length;
				sts = sts > 3 ? 3 : sts;
				$('.heroThumbs').slick({
					fade: false,
					mobileFirst: true,
					swipeToSlide: true,
					slidesToShow: sts,
					slidesToScroll: 1,
					asNavFor: '.heroSlider',
					dots: false,
					centerMode: true,
					focusOnSelect: true
				});

				/*if ($('.heroThumbs .hero-thumb').length <= 3) {
					$('.heroSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
						$('.heroThumbs .hero-thumb.slick-current').removeClass('slick-current');
						$('.heroThumbs .hero-thumb').eq(nextSlide).addClass('slick-current');
					});
				}*/
				//}
			}
		}

		function calculateScroll() {
			var scroll = $parent.scrollTop();
			var opacity = 1 - (scroll / (heroHeight / 2));
			var percentageLeft = scroll / heroHeight * 100;
			heroText.css('opacity', opacity).css('margin-top', -percentageLeft);

		}


		// We are loading <img src> into each slide, then using css object-fit to fill the space.
		// Doing this enables us to lazy load the slider images, saving on load times
		// IE does not support this method, so here is a fallback to set the <img src> URl as the slide BG image
		if (!Modernizr.objectfit) {
			$('.hero').each(function () {
				var $container = $(this),
					imgUrl = $container.find('img').data('lazy');
				if (imgUrl) {
					$container
						.css('backgroundImage', 'url(' + imgUrl + ')')
						.addClass('compat-object-fit');

					$container.find('img').addClass('u-hidden');
				}
			});
		}

		if (deviceWidth > 768 && heroContainer.length > 0) {

			var stickyDetect = new Waypoint.Inview({
				element: heroContainer[0],
				enter: function () {
					$parent.on('scroll', _.throttle(calculateScroll, 10));
				},
				exit: function () {
					$parent.on('scroll', _.throttle(calculateScroll, 10));
				},
				exited: function () {
					heroText.css({
						y: '-50%'
					});
					//$parent.unbind('scroll');
				}
			});
		}

		/*if(isLocal && pageType === 'home' && typeof conductorSlides != 'undefined' && conductorSlides != null && conductorSlides.length >= 1){
	 	$('.slideHolder').empty().append(symphony.templates.localSlide({slide:conductorSlides}));
	 	$('.heroSlider').slick('slickAdd',$('.slideHolder').html(),0,true);
  }*/

	};

})();
